import { render } from "./SupplierRIBCard.vue?vue&type=template&id=7c9399f8&scoped=true&ts=true&lang=pug"
import script from "./SupplierRIBCard.vue?vue&type=script&lang=ts"
export * from "./SupplierRIBCard.vue?vue&type=script&lang=ts"

import "./SupplierRIBCard.vue?vue&type=style&index=0&id=7c9399f8&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c9399f8"]])

export default __exports__